/**
 * Default library endpoint
 * @type {string}
 */
const GMO_PG_ENDPOINT_DEFAULT = 'https://stg.static.mul-pay.jp/ext/js/token.js';

const GMO = {
  /**
   * Import GMO Payment Gateway library
   */
  importGmoPGLibrary() {
    const gmoPGEndpoint = process.env.VUE_APP_GMO_PG_ENDPOINT
      ? process.env.VUE_APP_GMO_PG_ENDPOINT
      : GMO_PG_ENDPOINT_DEFAULT;

    const scriptTag = document.createElement('script');
    scriptTag.setAttribute('src', gmoPGEndpoint);
    document.head.appendChild(scriptTag)
  },

  /**
   * Get token
   *
   * @param cardObject
   * @param tokenCount
   * @return {Promise<any>}
   */
  getToken(cardObject, tokenCount = 2) {
    return new Promise((resolve, reject) => {
      Multipayment.init(process.env.VUE_APP_GMO_PG_API_KEY);
      Multipayment.getToken({
        ...cardObject,
        tokennumber: tokenCount,
      }, function (response) {
        if (response.resultCode === '000') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    })
  },
};

export default GMO;
